<template>

  <section class="bulk-delete-processing">

    <div class="bulk-delete-processing__icon">
       <i
        class="fas fa-trash-alt"
        aria-hidden="true"
      ></i
      >
    </div>

    <div class="bulk-delete-processing__body">
       <strong class="bulk-delete-processing__title">Đang xóa hóa đơn nháp</strong>
      <p class="bulk-delete-processing__text">
        Hệ thống đang xóa từng bản nháp hóa đơn. Vui lòng không đóng cửa sổ này.
      </p>
       <b-progress
        :value="progressPercent"
        max="100"
        show-progress
        animated
        variant="danger"
        class="bulk-delete-processing__progress"
      ></b-progress
      >
      <div class="bulk-delete-processing__meta">
         <span>{{ processed }} / {{ total }} đã xử lý</span> <span v-if="currentItemLabel"
          >Đang xóa: {{ currentItemLabel }}</span
        >
      </div>

    </div>

  </section>

</template>

<script>
  export default {
    name: 'BulkDeleteProcessingState',
    props: {
      progressPercent: {
        type: Number,
        default: 0,
      },
      processed: {
        type: Number,
        default: 0,
      },
      total: {
        type: Number,
        default: 0,
      },
      currentItemLabel: {
        type: String,
        default: '',
      },
    },
  }
</script>

<style scoped>
  .bulk-delete-processing {
    display: flex;
    align-items: flex-start;
    gap: 0.9rem;
    padding: 1rem;
    border: 1px solid #e1e7ef;
    border-radius: 12px;
    background: #fff;
  }

  .bulk-delete-processing__body {
    flex: 1;
  }

  .bulk-delete-processing__icon {
    width: 44px;
    height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #fff4f4;
    color: #c94c5f;
    flex: 0 0 auto;
    font-size: 1.1rem;
  }

  .bulk-delete-processing__title {
    display: block;
    color: #1f2a3d;
    font-size: 0.94rem;
    font-weight: 700;
  }

  .bulk-delete-processing__text {
    margin: 0.25rem 0 0;
    color: #556274;
    font-size: 0.82rem;
    line-height: 1.45;
  }

  .bulk-delete-processing__progress {
    margin-top: 0.75rem;
  }

  .bulk-delete-processing__meta {
    display: flex;
    justify-content: space-between;
    gap: 0.75rem;
    margin-top: 0.45rem;
    color: #6c7788;
    font-size: 0.78rem;
  }

  @media (max-width: 767.98px) {
    .bulk-delete-processing,
    .bulk-delete-processing__meta {
      flex-direction: column;
      align-items: stretch;
    }
  }
</style>
